// Author: Charles Nana Kwakye

function changeImage() {
    let i = document.querySelector('input').value;
    document.querySelector('#shownImage').src = `assets/student2/${i}.png`;
    const dates = ['Date section', '1550 BC', '0043', '1600', '1700', '1817', '1917', '1935', '1947', '1967', '1982', '2010', '2020'];
    document.querySelector('output').innerText = dates[i];
}

document.querySelector('#slide').addEventListener('change', function (e) {
    changeImage();
});
